import { render, staticRenderFns } from "./DeleteableChip.vue?vue&type=template&id=0786dbcb&scoped=true&"
import script from "./DeleteableChip.vue?vue&type=script&lang=ts&"
export * from "./DeleteableChip.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteableChip.vue?vue&type=style&index=0&id=0786dbcb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0786dbcb",
  null
  
)

export default component.exports